type GeoJSON = 'application/geo+json';
type JSON = 'application/json';
type KML = 'application/vnd.google-earth.kml+xml';
type KMZ = 'application/vnd.google-earth.kmz';
type GPX = 'application/gpx+xml';
type Zip = 'application/zip';
type DBF = "application/x-dbf";
type PRJ = "application/x-esri-crs"
type Shapefile = 'x-gis/x-shapefile'

export type MediaType = GeoJSON | JSON | KML | KMZ | GPX | Zip | Shapefile | DBF | PRJ;

export const MediaTypes: {[key: string]: MediaType} = {
    JSON: 'application/json',
    GeoJSON: 'application/geo+json',
    KML: 'application/vnd.google-earth.kml+xml',
    KMZ: 'application/vnd.google-earth.kmz',
    GPX: 'application/gpx+xml',
    Zip: 'application/zip',
    Shapefile: 'x-gis/x-shapefile',
    DBF: "application/x-dbf",
    PRJ: "application/x-esri-crs"
}